import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "overlay", "toggleButton"];
  static values = { direction: { type: String, default: "left" } };

  connect() {
    const hiddenClass = this.isRightAligned() ? "translate-x-full" : "-translate-x-full";
    this.contentTarget.classList.add(hiddenClass);
    this.overlayTarget.classList.add("hidden");
    this.updateButtonSymbol();
  }

  toggle() {
    const openClass = "translate-x-0";
    const hiddenClass = this.isRightAligned() ? "translate-x-full" : "-translate-x-full";

    this.contentTarget.classList.toggle(openClass);
    this.contentTarget.classList.toggle(hiddenClass);
    this.overlayTarget.classList.toggle("hidden");
    this.updateButtonSymbol();
  }

  updateButtonSymbol() {
    const isOpen = this.contentTarget.classList.contains("translate-x-0");
    this.toggleButtonTarget.innerHTML = isOpen
      ? (this.isRightAligned() ? "&lt;" : "&gt;")
      : (this.isRightAligned() ? "&gt;" : "&lt;");
  }

  isRightAligned() {
    return this.directionValue === "right";
  }
}